/**
 * EmptyFeatureCard — Starter-plan upgrade placeholder rendered by
 * `<StarterGate>` when a Starter customer navigates to a Pro-tier
 * route by direct URL paste / bookmark.
 *
 * Visually mirrors `<EmptyState>` but with a lock icon + accent CTA
 * to /dashboard/settings/billing. Always reachable: even on Starter,
 * Settings → Billing stays in the sidebar.
 */
import { useTranslation } from 'react-i18next';
import { Lock, Sparkles } from 'lucide-react';
import { ButtonLink } from '@/components/ui/Button';

interface EmptyFeatureCardProps {
  titleKey: string;
  descriptionKey: string;
}

export function EmptyFeatureCard({ titleKey, descriptionKey }: EmptyFeatureCardProps) {
  const { t } = useTranslation();
  return (
    <div className="mk-card flex flex-col items-center justify-center px-8 py-16 text-center">
      <div className="border-accent/20 bg-accent/10 text-accent mb-5 flex h-14 w-14 items-center justify-center rounded-2xl border">
        <Lock className="h-6 w-6" />
      </div>
      <h2 className="font-heading text-text-primary mb-2 text-2xl font-semibold">{t(titleKey)}</h2>
      <p className="text-text-secondary mb-6 max-w-md text-sm">{t(descriptionKey)}</p>
      <ButtonLink to="/dashboard/settings/billing">
        <Sparkles className="h-4 w-4" />
        {t('starterGate.upgradeCta')}
      </ButtonLink>
    </div>
  );
}
